import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:pt-68px md:pb-68px pt-8 pb-3 bg-everWhite flex flex-col px-5" }
const _hoisted_2 = { class: "max-w-1392px mx-auto w-full md:block hidden" }
const _hoisted_3 = { class: "flex flex-wrap w-full justify-between" }
const _hoisted_4 = { class: "block md:hidden" }
const _hoisted_5 = { class: "flex flex-wrap justify-between w-full" }

import { computed, onMounted } from 'vue'
import Container from './Container.vue'
import { ProjectSide } from '@/libs/types'
import ProjectSideArea from './ProjectSideArea.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSideModule',
  setup(__props) {

const projectSideList:ProjectSide[] = [
  {
    logo_src: '4everland',
    href: 'https://www.4everland.org/'
  },
  {
    logo_src: 'akord',
    href: 'https://akord.com/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-70'
  }, {
    logo_src: 'arconnect',
    href: 'https://www.arconnect.io/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-85'
  }, {
    logo_src: 'ar_news',
    href: 'https://arweave.news/',
    imgOpacity: 'opacity-85'
  }, {
    logo_src: 'bitkeep',
    href: 'https://bitkeep.com/'
  }, {
    logo_src: 'conflux',
    href: 'https://confluxnetwork.org/zh',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'decentland',
    href: 'https://www.decent.land/',
    styleOpacity: 'opacity-85'
  }, {
    logo_src: 'ethsign',
    href: 'https://www.ethsign.xyz/'
  }, {
    logo_src: 'knn3',
    href: 'https://www.knn3.xyz/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'metaforo',
    href: 'https://metaforo.io/',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'meson_network',
    href: 'https://meson.network/'
  }, {
    logo_src: 'moonbeam',
    href: 'https://moonbeam.network/'
  }, {
    logo_src: 'pianity',
    href: 'https://pianity.com/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'platon',
    href: 'https://www.platon.network/en',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'quest3',
    href: 'https://quest3.xyz/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'readon',
    href: 'https://readon.me/#/'
  }, {
    logo_src: 'redstone',
    href: 'https://redstone.finance/'
  }, {
    logo_src: 'relation',
    href: 'https://relationlabs.ai/#/home',
    imgOpacity: 'opacity-65'
  }, {
    logo_src: 'safeheron',
    href: 'https://www.safeheron.com/',
    styleOpacity: 'opacity-85'
  }, {
    logo_src: 'show_me',
    href: 'https://showme.fan/',
    styleOpacity: 'opacity-85',
    imgOpacity: 'opacity-55'
  }, {
    logo_src: 'warp',
    href: 'https://warp.cc/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-65'
  },
  {
    logo_src: 'echo',
    href: 'https://0xecho.com/',
    styleOpacity: 'opacity-90',
    imgOpacity: 'opacity-100'
  }
]
const pcProjectSideList = computed(() => {
  return projectSideList.slice(0, 11)
})
const pcProjectSideList2 = computed(() => {
  return projectSideList.slice(11)
})
const mobileList = computed(() => {
  const arrList:ProjectSide[][] = []
  let arr: ProjectSide[] = []

  const groupSize = 7
  const projectSidelength = Math.floor(projectSideList.length / groupSize)
  projectSideList.forEach((item) => {
    console.log(projectSidelength, arrList.length)
    if (arr.length !== groupSize) {
      arr.push(item)
    }
    if (arr.length === groupSize) {
      arrList.push(arr)
      arr = []
    } else if (arrList.length === projectSidelength) {
      arrList[arrList.length - 1].push(...arr)
      arr = []
    }
  })
  return arrList ?? []
})
onMounted(() => {
  console.log(mobileList.value)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProjectSideArea, { list: _unref(pcProjectSideList) }, null, 8, ["list"])
      ]),
      _createVNode(Container, { class: "flex flex-wrap justify-between w-full mt-10" }, {
        default: _withCtx(() => [
          _createVNode(ProjectSideArea, { list: _unref(pcProjectSideList2) }, null, 8, ["list"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(mobileList), (mobileItem, mobileIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: mobileIndex,
          class: "mb-4"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ProjectSideArea, { list: mobileItem }, null, 8, ["list"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})